import {DefaultInteraction} from "./interaction";


/**
 * Rotatable entity
 */
class Rotatable {
	obj = null
	axis = 'x'
	delta = 0.01
	duration = 1000
	start_time
	original_rotation
	onDone = () => {
	}

	constructor(obj, axis = 'x', delta = 0.01, duration = 1000, done = () => {
	}) {
		this.obj = obj
		this.original_rotation = obj.rotation.clone()
		this.axis = axis
		this.delta = delta
		this.duration = duration
		this.start_time = Date.now()
		this.onDone = done
	}

	update() {
		this.obj.rotation[this.axis] += this.delta
	}

	shouldRemove() {
		return this.duration <= 0 ? false : this.start_time + this.duration < Date.now()
	}

	doneReset() {
		this.reset()
		this.onDone()
	}

	reset() {
		this.obj.rotation.copy(this.original_rotation)
	}
}

export class RotateObject extends DefaultInteraction {

	scene = null
	rotationObjects = {
		// keyed by AlphaID of target
	};

	constructor(props) {
		super(props);
		this.scene = props.scene
	}

	key() {
		return "rotate_object"
	}

	/**
	 * Called onClick or when starting a proximity event
	 *
	 * @param interactionData
	 * @param metadata
	 * @param onSuccess
	 * @param onError
	 */
	interact(interactionData, metadata, onSuccess, onError) {
		console.log(`Interaction::${this.key()} - Run`, interactionData, metadata)

		const refObj = this.scene.get(interactionData.target_id) //TODO is target_id correct or should we use base item as target? - Proximity wise

		//If it's an infinite duration, allow the user to toggle
		if (!metadata || !metadata.skipToggle)
			if (this.rotationObjects[refObj.userData.alphaID] && this.rotationObjects[refObj.userData.alphaID].duration <= 0) {
				this._removeRotatable(refObj.userData.alphaID)
				return
			}

		this._addRotatable(refObj.userData.alphaID, refObj, interactionData.axis, interactionData.delta, interactionData.duration, onSuccess)

		return !interactionData.blocking //If we are blocking return false so we dont call onSuccess
	}

	/**
	 * Called each frame to update our interactables
	 *
	 * @param player
	 * @param interactions
	 */
	onUpdate(player, interactions = []) {
		for (let key in this.rotationObjects) {
			const rObj = this.rotationObjects[key]
			if (rObj.shouldRemove())
				this._removeRotatable(key)
			else
				rObj.update()
		}
	}


	/**
	 * TODO Start rotation object on enter (if proximity)
	 * @param interaction
	 * @param interactable
	 */
	onProximityEnter(interaction, interactable) {
		console.log("Proximity enter", interactable.userData.alphaID, interactable)
		this.runInteraction(interaction.data, {
			skipToggle: true,
		}, () => {
		}, () => {
		})
	}

	/**
	 * TODO remove rotation object on exit
	 * @param interactable
	 */
	onProximityExit(interactable) {
		console.log("Proximity exit", interactable.userData.alphaID, interactable)
		this._removeRotatable(interactable.userData.alphaID)
	}

	_removeRotatable(alphaID) {
		if (!this.rotationObjects[alphaID])
			return

		this.rotationObjects[alphaID].doneReset()
		delete this.rotationObjects[alphaID]
	}

	_addRotatable(alphaID, obj, axis = 'x', delta = 0.01, duration = 1000, onDone = () => {
	}) {
		this.rotationObjects[alphaID] = new Rotatable(obj, axis, delta, duration, onDone)
	}
}